// extracted by mini-css-extract-plugin
module.exports = {"container":"UserBadges_container__1aH3s","inlineContainer":"UserBadges_inlineContainer__mi6eS"};